(() => {
  const form = document.getElementById('OylinBespokeContact');
  if (!form) return;
  const key = 'oylin.inquiry.pending.v1';
  let storage;
  try { storage = window.sessionStorage; } catch (_) { return; }
  const now = () => Date.now();
  try {
    if (form.querySelector('[data-oylin-inquiry-success]')) {
      const raw = storage.getItem(key);
      storage.removeItem(key);
      if (raw) {
        const pending = JSON.parse(raw);
        if (pending.token && pending.time <= now() && now() - pending.time < 3600000) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: pending.internal ? 'oylin_qa_inquiry_success' : 'generate_lead',
            form_id: 'OylinBespokeContact',
            lead_source: 'project_inquiry',
            internal_qa: Boolean(pending.internal)
          });
        }
      }
    } else if (form.querySelector('[role="alert"]')) {
      storage.removeItem(key);
    }
  } catch (_) {}
  form.addEventListener('submit', () => {
    try {
      const brief = form.querySelector('[name="contact[body]"]');
      const internal = new URLSearchParams(window.location.search).get('qa') === '1' ||
        /OYLIN-QA-|Internal QA test only/i.test(brief ? brief.value : '');
      storage.setItem(key, JSON.stringify({
        token: window.crypto.randomUUID(), time: now(), internal
      }));
    } catch (_) {}
  });
})();
